module.exports = __webpack_public_path__ + "img/defense-2011-doctor-1.2099d3f3.jpg";